import Header from '../../Header/Header'
import styles from '../styles.css'

export default function ReviewForm({ form, checkingBalance, setCheckingBalance, showFeeSchedule = false, showNotes = false }) {
  const account = form.trust_account || form.account

  if (!account?.number) return null

  const mappedForm = {
    account: {
      floorAmount: account.floorAmount || 0,
      hasBudget: account.hasBudget || false,
      pCardLast4: account.pCardLast4,
    },
  }

  return (
    <div className={`${styles.sectionThree} ${styles.sectionThreeTop}`}>
      <Header
        form={mappedForm}
        number={account.number}
        beneficiary={account.beneficiary}
        otherDistributions={form.otherDistributions}
        checkingBalance={checkingBalance}
        setCheckingBalance={setCheckingBalance}
        showFeeSchedule={showFeeSchedule}
        showNotes={showNotes}
        touchNav
      />
    </div>
  )
}
